import type { TDcDraft, IPaymentSystemsData } from '@alfa-bank/site-dc-draft/src/models';

import type { TX5BankFormShort } from '../models';

/**
 * Конвертирует конфиг карт новой формы в старый конфиг для черновиков.
 * Можно будет удалить когда переедем с dc-form и порефачим черновик
 */
export function convertCardsConfig(cards: TX5BankFormShort['cards']) {
    const newConfig: TDcDraft['cards'] = [];

    Object.keys(cards).forEach((paySystem: string) => {
        const paymentSystem = paySystem as keyof IPaymentSystemsData;

        cards[paySystem].forEach(card => {
            const {
                cardParams: { cardId, packetId, prefillContractId },
                ...rest
            } = card;
            const findCardIndex = newConfig.findIndex(item => item.id === prefillContractId);

            if (findCardIndex === -1) {
                newConfig.push({
                    ...rest,
                    id: prefillContractId,
                    cardId: { [paymentSystem]: cardId },
                    packetId: { [paymentSystem]: packetId },
                });
            } else {
                newConfig[findCardIndex].cardId[paymentSystem] = cardId;
                newConfig[findCardIndex].packetId[paymentSystem] = packetId;
            }
        });
    });

    return newConfig;
}

export const getQueriesPassedToForm = (
    queriesFromURL: { [key: string]: string | unknown },
    listPassedQueries: string[]
) => {
    return Object.keys(queriesFromURL).reduce((acc: { [key: string]: string }, queryName) => {
        if (listPassedQueries.includes(queryName)) {
            const queryValue = queriesFromURL[queryName];
            if (typeof queryValue === 'string') {
                acc[queryName] = queryValue;
            }
        }

        return acc;
    }, {});
};
